import React from 'react';
// import PropTypes from 'prop-types';
import { Restaurant } from '@firsttable/types';
import ListItemCard, { ListItemCardProps } from '../ListItemCard/ListItemCard';
import withFireBaseAvailability from '../../hocs/withFireBaseAvailability';

const RestaurantOtherItem = ({
  restaurant,
  ...props
}: {
  restaurant: Restaurant;
} & Omit<ListItemCardProps, 'item' | 'img' | 'subTitle'>) => {
  if (!restaurant.images) {
    return null;
  }
  const [img] = restaurant.images.edges;
  const subTitle =
    restaurant.cuisines && restaurant.cuisines.edges.length
      ? restaurant.cuisines.edges.map(({ node: { title } }) => title).join(', ')
      : null;

  return (
    <ListItemCard
      item={restaurant}
      img={img?.node?.url ? { ...img.node, url: img.node.url } : undefined}
      subTitle={subTitle}
      {...props}
    />
  );
};

export default withFireBaseAvailability(RestaurantOtherItem);
